import { NavLink } from 'react-router-dom'
import { 
  LayoutDashboard, 
  ShoppingBag, 
  FileText, 
  Package, 
  Truck,
  Mail,
  Globe,
  Box,
  Users,
  Instagram,
  Music,
  Grid3x3,
  Store,
  Building2
} from 'lucide-react'
import Logo from './Logo'

const menuItems = [
  { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { path: '/shopify', icon: ShoppingBag, label: 'Shopify' },
  { path: '/moloni', icon: FileText, label: 'Moloni' },
  { path: '/batch', icon: Package, label: 'Batch' },
  { path: '/affiliatly', icon: Users, label: 'Affiliatly' },
  { path: '/instagram', icon: Instagram, label: 'Instagram' },
  { path: '/tiktok', icon: Music, label: 'TikTok' },
  { path: '/applications', icon: Grid3x3, label: 'Aplicações' },
  { path: '/store-vila-nova-gaia', icon: Store, label: 'Loja V.N. Gaia' },
  { path: '/store-colombo', icon: Building2, label: 'Loja CC Colombo' },
  { path: '/dpd', icon: Truck, label: 'DPD' },
  { path: '/ctt', icon: Mail, label: 'CTT' },
  { path: '/dhl', icon: Globe, label: 'DHL' },
  { path: '/mrw', icon: Box, label: 'MRW' },
]

export default function Sidebar() {
  return (
    <aside className="w-64 bg-white shadow-lg border-r border-gray-200 flex flex-col">
      <div className="p-6 border-b border-gray-200">
        <Logo size="sm" className="mb-2" />
        <p className="text-xs text-gray-500 text-center mt-2">Backoffice Dashboard</p>
      </div>
      <nav className="flex-1 p-4 space-y-2">
        {menuItems.map((item) => {
          const Icon = item.icon
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                  isActive
                    ? 'bg-black text-white font-medium'
                    : 'text-gray-700 hover:bg-gray-100'
                }`
              }
            >
              <Icon className="w-5 h-5" />
              <span>{item.label}</span>
            </NavLink>
          )
        })}
      </nav>
      <div className="p-4 border-t border-gray-200">
        <p className="text-xs text-gray-500 text-center">
          © 2024 Guilty Beauty
        </p>
      </div>
    </aside>
  )
}
